import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import HotRecommend from './components/HotRecommend';
import LatestUpdate from './components/LatestUpdate';
import PartnerShowcase from './components/PartnerShowcase';
import FAQ from './components/FAQ';
import { Link } from 'react-router-dom';
import { hotRecommends } from '@/mocks/home';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <Navbar />

      <main>
        <Hero />
        <CategoryNav />
        <HotRecommend />
        <LatestUpdate />

        <section className="py-12 md:py-16" aria-label="影视资讯">
          <div className="max-w-[1400px] mx-auto px-4 md:px-6">
            <div className="flex items-center justify-between mb-8">
              <div>
                <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950">
                  影视资讯
                </h2>
                <p className="text-sm text-foreground-500 mt-1">
                  最新影视动态与深度解读
                </p>
              </div>
              <Link
                to="/category/dianying"
                className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                更多资讯
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-sm"></i>
                </div>
              </Link>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {[1, 2, 4].map((articleId) => {
                const article = {
                  1: { title: '《流浪地球3》定档2026暑期 郭帆：这次我们要去比邻星', date: '2026-07-28', category: '电影' },
                  2: { title: '《三体：黑暗森林》口碑爆棚 网友：国产科幻剧新高度', date: '2026-07-25', category: '电视剧' },
                  4: { title: '国漫崛起：《雾山五行》水墨画风征服全球观众', date: '2026-07-20', category: '动漫' },
                }[articleId];
                if (!article) return null;
                return (
                  <Link
                    key={articleId}
                    to={`/article/${articleId}`}
                    className="group p-5 rounded-lg bg-background-100 hover:bg-accent-50 transition-colors cursor-pointer"
                  >
                    <span className="inline-block px-2.5 py-0.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
                      {article.category}
                    </span>
                    <h3 className="text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors mb-2 line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="text-xs text-foreground-500">{article.date}</p>
                  </Link>
                );
              })}
            </div>
          </div>
        </section>

        <PartnerShowcase />
        <FAQ />
      </main>

      <Footer />
    </>
  );
}